export const API_REQUEST = '[app] API Request';

export const apiRequest = (method, url, body, onSuccess, onError, throttle=0, retry=false) => ({
  type: API_REQUEST,
  payload: body,
  meta: { method, url, onSuccess, onError, throttle, retry }
});




// WEBPACK FOOTER //
// ./src/redux/actions/api.js